export class UnexpectedError extends Error {
    constructor() {
        super('Something was wrong, please try again!');
        this.name = 'UnexpectedError';
    }
}
